module.exports = __webpack_public_path__ + "img/ci_hyundai.18d29d81.svg";